import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import Logo from "../../assets/assets/Nibss-Logo.png";
import Aside2 from "../../pages/Terms/Aside2";

const Navbar = () => {
  const [menuChecked, setMenuChecked] = useState(false);

  return (
    <nav>
      <div className="nav-left">
        <Link to="/">
          <div className="nav-left-logo">
            <img src={Logo} alt="nibss-logo" />
          </div>
        </Link>
      </div>

      <input type="checkbox" checked={menuChecked} id="nav-check2" />
      <Aside2 showMenu={(value) => setMenuChecked(value)} />

      <div className="nav-mid" data-testid="nav-mid" onClick={() => setMenuChecked(!menuChecked)}>
        <label htmlFor="nav-check2">
          <div className="nav-mid-item1"></div>
          <div className="nav-mid-item2"></div>
          <div className="nav-mid-item3"></div>
        </label>
      </div>

      <div className="nav-right">
        <NavLink to="/login" className="sign-in">
          <span>SIGN IN</span>
        </NavLink>

        <NavLink to="/sign-up">
          <button className="nav-button">SIGN UP</button>
        </NavLink>
      </div>
    </nav>
  );
};

export default Navbar;
